import React, { useState } from 'react';
import { Plus, Edit, Check, X } from 'lucide-react';
import { Agency, ActiveStatus, AgencyType, AGENCY_TYPES } from '../types/masterData';
interface AgencyListProps {
  agencies: Agency[];
  onSave: (agency: Agency) => void;
}
export function AgencyList({
  agencies,
  onSave
}: AgencyListProps) {
  const [editingId, setEditingId] = useState<string | null>(null);
  const [editForm, setEditForm] = useState<Partial<Agency>>({});
  const [isAdding, setIsAdding] = useState(false);
  const handleEdit = (agency: Agency) => {
    setEditingId(agency.id);
    setEditForm(agency);
    setIsAdding(false);
  };
  const handleAdd = () => {
    setEditingId('new');
    setEditForm({
      id: `agency-${Date.now()}`,
      name: '',
      type: 'Police',
      status: 'Active'
    });
    setIsAdding(true);
  };
  const handleSave = () => {
    if (editForm.name && editForm.id && editForm.type) {
      onSave(editForm as Agency);
      setEditingId(null);
      setIsAdding(false);
    }
  };
  const handleCancel = () => {
    setEditingId(null);
    setIsAdding(false);
  };
  return <div className="space-y-6 max-w-5xl mx-auto" data-id="element-67" data-mp="bshooxc8u4to">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-68" data-mp="bry8pm65lqia">
        <div data-id="element-69" data-mp="pqxxctto25eg">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-70" data-mp="prqxvd217yo5">Reporting Agencies</h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-71" data-mp="ku7fq227r1qx">Manage authorized reporting agencies</p>
        </div>
        <button onClick={handleAdd} disabled={isAdding} className="flex items-center gap-2 px-4 py-2 bg-blue-800 text-white text-sm font-medium rounded-md hover:bg-blue-900 transition-colors disabled:opacity-50" data-id="element-72" data-mp="3t9r9r3apko71">
          <Plus size={16} data-id="element-73" data-mp="6upolg1g3cee" />
          Add Agency
        </button>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-74" data-mp="21n1nqr6b176">
        <div className="overflow-x-auto" data-id="element-75" data-mp="3ahg9lh7fv4cm">
          <table className="w-full text-left border-collapse" data-id="element-76" data-mp="3agew762ya5rq">
            <thead data-id="element-77" data-mp="35ilryil7jlu3">
              <tr className="bg-gray-50 border-b border-gray-200 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-78" data-mp="35j50x9svqzvz">
                <th className="px-6 py-4 w-2/5" data-id="element-79" data-mp="1efd5p5ij7317">Agency Name</th>
                <th className="px-6 py-4 w-1/4" data-id="element-80" data-mp="1eds8t98qv806">Type</th>
                <th className="px-6 py-4 w-1/6 text-center" data-id="element-81" data-mp="1j5jvh8os4tl1">Status</th>
                <th className="px-6 py-4 w-1/12 text-center" data-id="element-82" data-mp="1j8ftsy4jhka0">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-83" data-mp="qhnys3z7n1o9">
              {isAdding && <tr className="bg-blue-50" data-id="element-84" data-mp="vghdu0u5b0qj">
                  <td className="px-6 py-4" data-id="element-85" data-mp="vhiow5b5vn89">
                    <input autoFocus type="text" value={editForm.name || ''} onChange={e => setEditForm({
                  ...editForm,
                  name: e.target.value
                })} placeholder="Agency Name" className="w-full border border-gray-300 rounded px-2 py-1 text-sm" data-id="element-86" data-mp="vibzxih5kyw7" />
                  </td>
                  <td className="px-6 py-4" data-id="element-87" data-mp="2awg7k730mu79">
                    <select value={editForm.type || 'Police'} onChange={e => setEditForm({
                  ...editForm,
                  type: e.target.value as AgencyType
                })} className="w-full border border-gray-300 rounded px-2 py-1 text-sm" data-id="element-88" data-mp="2fwcae2zz8fl8">
                      {AGENCY_TYPES.map(t => <option key={t} value={t} data-id="element-89" data-mp="2l0wlguwxq18f">{t}</option>)}
                    </select>
                  </td>
                  <td className="px-6 py-4 text-center" data-id="element-90" data-mp="2g9em2bak88pk">
                    <select value={editForm.status || 'Active'} onChange={e => setEditForm({
                  ...editForm,
                  status: e.target.value as ActiveStatus
                })} className="border border-gray-300 rounded px-2 py-1 text-sm" data-id="element-91" data-mp="2c8uq3b1q3b50">
                      <option value="Active" data-id="element-92" data-mp="22ayginofoo90">Active</option>
                      <option value="Inactive" data-id="element-93" data-mp="22crme0r834fy">Inactive</option>
                    </select>
                  </td>
                  <td className="px-6 py-4 text-center" data-id="element-94" data-mp="1xdezjg0cpxdd">
                    <div className="flex items-center justify-center gap-2" data-id="element-95" data-mp="1tbblqkq7mgox">
                      <button onClick={handleSave} className="p-1 text-green-600 hover:bg-green-100 rounded" title="Save" data-id="element-96" data-mp="3rpwgy6yie3a3"><Check size={18} data-id="element-97" data-mp="3nnrovcnplepk" /></button>
                      <button onClick={handleCancel} className="p-1 text-gray-500 hover:bg-gray-200 rounded" title="Cancel" data-id="element-98" data-mp="3nlx1zssvnciu"><X size={18} data-id="element-99" data-mp="3up4xwecvewm8" /></button>
                    </div>
                  </td>
                </tr>}
              {agencies.map(agency => <tr key={agency.id} className="hover:bg-gray-50" data-id="element-100" data-mp="3lprrjuk1mo5q">
                  {editingId === agency.id ? <>
                      <td className="px-6 py-4" data-id="element-101" data-mp="3c0qas25oc2qp">
                        <input autoFocus type="text" value={editForm.name || ''} onChange={e => setEditForm({
                    ...editForm,
                    name: e.target.value
                  })} className="w-full border border-gray-300 rounded px-2 py-1 text-sm" data-id="element-102" data-mp="3bzyeep4960zd" />
                      </td>
                      <td className="px-6 py-4" data-id="element-103" data-mp="320poc7cid6ia">
                        <select value={editForm.type || 'Police'} onChange={e => setEditForm({
                    ...editForm,
                    type: e.target.value as AgencyType
                  })} className="w-full border border-gray-300 rounded px-2 py-1 text-sm" data-id="element-104" data-mp="372orbg4c61ep">
                          {AGENCY_TYPES.map(t => <option key={t} value={t} data-id="element-105" data-mp="2y31n6mk82hhy">{t}</option>)}
                        </select>
                      </td>
                      <td className="px-6 py-4 text-center" data-id="element-106" data-mp="29gc4cys3po7d">
                        <select value={editForm.status || 'Active'} onChange={e => setEditForm({
                    ...editForm,
                    status: e.target.value as ActiveStatus
                  })} className="border border-gray-300 rounded px-2 py-1 text-sm" data-id="element-107" data-mp="29hwzoqm8pb6a">
                          <option value="Active" data-id="element-108" data-mp="2jgcogmxso8cm">Active</option>
                          <option value="Inactive" data-id="element-109" data-mp="2xcq924xmkpvb">Inactive</option>
                        </select>
                      </td>
                      <td className="px-6 py-4 text-center" data-id="element-110" data-mp="2scu4o4l0mwf8">
                        <div className="flex items-center justify-center gap-2" data-id="element-111" data-mp="372syjv5jflow">
                          <button onClick={handleSave} className="p-1 text-green-600 hover:bg-green-100 rounded" title="Save" data-id="element-112" data-mp="32480o2drde3m"><Check size={18} data-id="element-113" data-mp="3g3zkijqyhopj" /></button>
                          <button onClick={handleCancel} className="p-1 text-gray-500 hover:bg-gray-200 rounded" title="Cancel" data-id="element-114" data-mp="3g2g2anlqp3l4"><X size={18} data-id="element-115" data-mp="3b3cx935rexd5" /></button>
                        </div>
                      </td>
                    </> : <>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-116" data-mp="2drmiy100u4ut">
                        <span className="text-sm font-medium text-gray-900" data-id="element-117" data-mp="2hs6itcbzbmkn">{agency.name}</span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-118" data-mp="2mk80jdrx25i2">
                        <span className="text-sm text-gray-600" data-id="element-119" data-mp="2rj12qa1r6a2x">{agency.type}</span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center" data-id="element-120" data-mp="2wgt6c1brfkmy">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${agency.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-121" data-mp="31gypsu7vm0ty">
                          {agency.status}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center" data-id="element-122" data-mp="1b3q0z4t0vmr7">
                        <button onClick={() => handleEdit(agency)} className="p-1.5 bg-blue-100 text-blue-600 rounded hover:bg-blue-200 transition-colors" title="Edit" data-id="element-123" data-mp="13kqid1ddxz8w">
                          <Edit size={16} data-id="element-124" data-mp="yspd3zemx8sd" />
                        </button>
                      </td>
                    </>}
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}